import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./index.css";
import { Root } from "./pages/Root";
import { Admin } from "./pages/Admin";

const router = createBrowserRouter([
    {
        path: "/",
        Component: Root,
    },
    {
        path: "/admin",
        Component: Admin,
    }
]);

export function App() {
    return (
        <RouterProvider router={router} />
    )
}

export default App;
